import { useI18n } from 'next-localization';
import PerformanceTableBase from 'components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/Tables/PerformanceTableBase';
import { endpoints } from '../performanceEndpoints';

const CumulativeQuarterlyTable = ({ className }: string) => {
  const { t } = useI18n();
  return (
    <PerformanceTableBase
      title={t('fundDetailsCumulativeQuarterlyPerformanceTitle')}
      footnoteText={t('fundDetailsPerformanceCumulativeFootnote')}
      wrapperId="quarterlyCumulativeWrapper"
      tableId="quarterlyCumulativeTable"
      endpoint={endpoints.CUMULATIVE}
      quarterly
      className={className}
    />
  );
};

export default CumulativeQuarterlyTable;
